// Templates hold their tags as text, so older ones can differ from the tag list in case or
// stray spaces ("OFSTED", "Mental Health "). Match the way the customer app does.
const normaliseTag = (tag) => (tag ?? '').trim().toLowerCase();

export const templateHasTag = (template, tag) =>
  template.surveysTags?.some((x) => normaliseTag(x) === normaliseTag(tag)) ??
  false;
